export const fontSize = {
  xs: "10px",
  sm: "11px",
  md: "12px",
  lg: "13px",
  xl: "14px",
};

export const addButtonTextStyle = {
  color: "white",
  fontWeight: "normal",
  cursor: "pointer",
};

export const tableColumnWrap = (size = "200px") => ({
  width: size,
  whiteSpace: "pre-wrap",
  overflowWrap: "anywhere",
});
